/**
 * Swapping specific events.
 */
export enum SwapEventName {
  SWAP_AUTOROUTER_VISUALIZATION_EXPANDED = 'Swap Autorouter Visualization Expanded',
  SWAP_DETAILS_EXPANDED = 'Swap Details Expanded',
  SWAP_ERROR = 'Swap Error',
  SWAP_ESTIMATE_GAS_CALL_FAILED = 'Swap Estimate Gas Call Failed',
  SWAP_FIRST_ACTION = 'Swap First Action',
  SWAP_FIRST_SIGNATURE_REQUESTED = 'Swap First Signature Requested',
  SWAP_MAX_TOKEN_AMOUNT_SELECTED = 'Swap Max Token Amount Selected',
  SWAP_MODIFIED_IN_WALLET = 'Swap Modified in Wallet',
  SWAP_PRICE_UPDATE_ACKNOWLEDGED = 'Swap Price Update Acknowledged',
  SWAP_QUOTE_FETCH = 'Swap Quote Fetch',
  SWAP_QUOTE_RECEIVED = 'Swap Quote Received',
  SWAP_SIGNED = 'Swap Signed',
  SWAP_SUBMITTED_BUTTON_CLICKED = 'Swap Submit Button Clicked',
  SWAP_TOKENS_REVERSED = 'Swap Tokens Reversed',
  SWAP_TRANSACTION_COMPLETED = 'Swap Transaction Completed',
  SWAP_TRANSACTION_FAILED = 'Swap Transaction Failed',
}
